import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pageable } from '@b3networks/api/common';
import { map, tap } from 'rxjs';
import { MediaFile, ReqGetJWT, ResGetJWT, SourceType } from './medias.model';
import { MediasQuery } from './medias.query';
import { MediasStore } from './medias.store';

@Injectable({
  providedIn: 'root'
})
export class MediasService {
  constructor(
    private http: HttpClient,
    private store: MediasStore,
    private query: MediasQuery
  ) {}

  getJWT(req: ReqGetJWT) {
    return this.http.post<ResGetJWT>('inbox/private/v1/medias/_upload', req);
  }

  getJWTByMedia(mediaId: string) {
    return this.http.post<ResGetJWT>(`inbox/private/v1/medias/${mediaId}/_download`, {});
  }

  getListJWTByMedias(mediaIds: string[]) {
    // max is 10 mediaIds
    return this.http.post<{ [key: string]: string }[]>(`inbox/private/v1/medias/_downloadBulk`, {
      mediaIds
    });
  }

  ackMediaToMessageId(mediaId: string, messageId: string) {
    return this.http.put<ResGetJWT>(`inbox/private/v1/medias/${mediaId}/_ack`, { messageId });
  }

  getDetailMedia(mediaId: string) {
    return this.http.get<MediaFile>(`inbox/private/v1/medias/${mediaId}`).pipe(
      map(x => new MediaFile(x)),
      tap(x => this.store.upsertMany([x], { baseClass: MediaFile }))
    );
  }

  getListMediaByChannelId(channelId: string, sourceType: SourceType, pageable: Pageable) {
    let params = new HttpParams();
    Object.keys(pageable).forEach(key => {
      if (pageable?.[key]) params = params.append(key, pageable?.[key] + '');
    });
    if (channelId) params = params.append('channelId', channelId);
    if (sourceType) params = params.append('sourceType', sourceType);
    return this.http.get<MediaFile[]>(`inbox/private/v1/medias`, { params }).pipe(
      map(ls => ls?.map(x => new MediaFile(x))),
      tap(ls => this.store.upsertMany(ls, { baseClass: MediaFile }))
    );
  }
}
